import React from 'react';
//import userLogo from 'assets/images/user.png';
//import dataservice from 'utils/dataservice';
//import {SideMenu} from 'react-sidemenu'; 
//import 'assets/css/react-sidemenu.css';
import {BrowserRouter as Router, Switch, Route, Redirect} from "react-router-dom";
import ComponentWrapper from 'components/componentwrapper';
import {loadableComp,translate,resolveRouterPath,getUpdatedPageUrl} from 'utils/common';
import {DEFAULT_LANDING_PAGE,SHOW_LOADER,PATH_CHANGED, H1_CHANGED, CHAT_ACTIVATED} from 'utils/constants';
// import Preloader from 'components/preloader';
import MessagePanel from 'components/messagepanel';
import LeftPanel from 'components/leftpanel'; 

const NoMatch = ({ location }) => (
    <Redirect to={resolveRouterPath(DEFAULT_LANDING_PAGE,{lang:app.selectedLocale})}/>
);
class TopPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {activeLeftMenu: DEFAULT_LANDING_PAGE };
        this.handlePathChange = this.handlePathChange.bind(this);        
        // this.handleH1Change = this.handleH1Change.bind(this);        
        const ev = {}; 
        ev[PATH_CHANGED] = this.handlePathChange;
        // ev[H1_CHANGED] = this.handleH1Change;
        app.events.subscribe(ev);  
    }
    handlePathChange([route]){
        let title = (typeof route["title"] === "function")? route["title"]():  route["title"];         
        this.setState({activeLeftMenu: translate(title)})
    }
    // handleH1Change([{title}]) {
    //     this.setState({activeLeftMenu: translate(title)})
    // } 
    render(){
        let {activeLeftMenu} = this.state;
        return(<React.Fragment>
            <nav aria-label="breadcrumb" className="d-none">
                    <ol className="breadcrumb">
                        {/* <li className="breadcrumb-item"><a ><i className="fas fa-home"></i></a></li>
                        <li className="breadcrumb-item"><a href="#">Products</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Manage Products</li> */}
                    </ol>
                </nav>
                {app.userAuth.impersonateUserEmail && <h5 className="admin-msg-title text-right">{translate('impersonate_user_msg')}</h5>}
                <h1>{activeLeftMenu}</h1>
        </React.Fragment>)
    }
} 
class ContentPanel extends React.Component {
    constructor(props) {
        super(props);  
        this.toggleLoader = this.toggleLoader.bind(this);    
        const ev = {};
        ev[SHOW_LOADER] = this.toggleLoader;  
        ev[PATH_CHANGED] = this.handlePathChange;     
        app.events.subscribe(ev); 
        this.isLoading = true;
    }
    handlePathChange([route]){ 
        // this.setState({activeLeftMenu: translate(route["title"]), activeRouteName:route["name"]})
        // var classList = document.getElementById('contentpanel').classList
        // for(var i in classList) {
        //     if(classList[i].startsWith('pg-')) {
        //         document.getElementById('contentpanel').classList.remove(classList[i])
        //     }
        // }
        var classList = document.getElementById('contentpanel').classList
        var bodyClassList = document.body.classList
        for(var i = 0; i < classList.length; i++) {
            if(classList[i].indexOf("pg-")!= -1) classList.remove(classList[i]); 
        }
        for(var i = 0; i < bodyClassList.length; i++) {
            if(bodyClassList[i].indexOf("wrap-")!= -1) bodyClassList.remove(bodyClassList[i]); 
        } 
        //content-panel pg-pricing pg-helpcenter pg-openorders pg-performance pg-manageinventory pg-shippingpromotions pg-pricepromotions pg-warehouses pg-brands pg-manageproducts pg-dashboard
        //document.getElementById('contentpanel').classList.remove('pg-dashboard')
        ///TODO remove existing classes
        document.getElementById('contentpanel').classList.add('pg-'+route["name"]);
        document.body.classList.add('wrap-'+route["name"])
    }
    toggleLoader(params){
        this.isLoading = params[0].status;
    }
    
    render(){
        // let {activeLeftMenu, activeRouteName} = this.props;
        let activeRouteName=''
        return(
            <div id="contentpanel" className={"content-panel"}>
                <TopPanel /> 
                <div className="content-pad ">
                    {/* <Preloader/> */}
                    <MessagePanel/> 
                    {/* {this.state.isLoading && <Preloader/>}  */}
                    <Router>
                        <Switch>
                            {app.routes.map((route)=> {
                                let component = ComponentWrapper(loadableComp(route.componentId), route)
                                return <Route {...route} key={route.name} component={component}/>
                            })}
                            <Route component={NoMatch} />
                        </Switch>
                    </Router>
                    
                </div>
            </div> 
        )
    }
}

class Content extends React.Component {
    constructor(props){
        super(props);  
        this.state = {activeLeftMenu: DEFAULT_LANDING_PAGE, activeRouteName: DEFAULT_LANDING_PAGE}; 
        const ev = {};  
        app.events.subscribe(ev);
        this.toggleChatInbox = this.toggleChatInbox.bind(this);
        window.isChatActive = false;
    }
    toggleChatInbox(){
    	window.isChatActive = !window.isChatActive;
    	app.events.trigger(CHAT_ACTIVATED);
    }
     
    render(){
        return(
            <React.Fragment>
        		<main role="content" className="content-wrap">
	                <div className="container-fluid">
	                    <div className="content-box"> 
	                         <LeftPanel /> 
	                         <ContentPanel/>
	                         {/* <ContentPanel activeLeftMenu={this.state.activeLeftMenu} activeRouteName={this.state.activeRouteName}/> */}
	                    </div>
	                </div>
	            </main> 
            </React.Fragment>
        )
    }
}

export default Content;
